import React, {useEffect, useState} from 'react';

import {FormattedDate, useIntl} from 'react-intl';
import {IExerciseDialogue} from '../../redux/exercise/interfaces';

import './styles.scss';
import {ButtonVariant, GritxButton} from '@wholesalechange/chatcomponent';

type Props = {
  card: IExerciseDialogue;
  onClick: () => void;
}

export const ExerciseCard = ({
  card,
  onClick
}: Props): JSX.Element => {
  const [cardData, setCardData] = useState<IExerciseDialogue>(card);
  const intl = useIntl();

  useEffect(() => {
    setCardData(card);
  }, [card]);

  function handleClick() {
    onClick();
  }

  function renderBasicCard() {
    return <div className="exercise-area">
      <div className="exercise-area__card-place">
        <div className="exercise-area__card">
          <div className="exercise-area__title">
            <div className="exercise-area__title-wrapper">
              <button className="exercise-area__title__text" onClick={handleClick}>{cardData.dialogName}</button>
              <div className="exercise-area__title__date">{cardData.dialogUserDate != null
                && <FormattedDate
                  value={cardData.dialogUserDate}
                  year="numeric"
                  month="long"
                  hour="numeric"
                  minute="numeric"
                  day="2-digit"
                />}</div>
            </div>
          </div>
          <div className="exercise-area__title-percent" style={{
            background: `linear-gradient(to left, #f2f2f2 ${100 - cardData.percentage}%, #EBA378 ${100 - cardData.percentage}%)`
          }}>
          </div>
        </div>
        <div className="exercise-area__bottom">
          <div className="exercise-area__btn">
            <GritxButton
              title={intl.formatMessage({
                id: 'gritx.exercise.card.open',
                defaultMessage: 'Open'
              })}
              variant={ButtonVariant.Outline}
              className="exercise-area__button"
              onClick={handleClick}
            />
          </div>
        </div>
      </div>
    </div>;
  }

  return renderBasicCard();
};
